import { render } from "./UeTripsForeignListView.vue?vue&type=template&id=68ae58c6&scoped=true"
import script from "./UeTripsForeignListView.vue?vue&type=script&lang=js"
export * from "./UeTripsForeignListView.vue?vue&type=script&lang=js"

import "./UeTripsForeignListView.vue?vue&type=style&index=0&id=68ae58c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ae58c6"]])

export default __exports__